var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConditionIconNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43214"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 108",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#D8E4F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 43218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.375 16.9167L19.8333 18.3751L18.375 19.8334",
    stroke: "#235594",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.33333 10.5001C9.97765 10.5001 10.5 9.97774 10.5 9.33341C10.5 8.68908 9.97765 8.16675 9.33333 8.16675C8.689 8.16675 8.16667 8.68908 8.16667 9.33341C8.16667 9.97774 8.689 10.5001 9.33333 10.5001Z",
    stroke: "#235594",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5 9.33325H12.8333C13.4777 9.33325 14 9.85559 14 10.4999V17.2083C14 17.8526 14.5223 18.3749 15.1667 18.3749H19.8333",
    stroke: "#235594",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditionIconNode);
export default __webpack_public_path__ + "static/media/conditionIconNode.f4bf42df952ab3e0e4336866b6321d69.svg";
export { ForwardRef as ReactComponent };